<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <button @click="$router.push('/supplies-manager')" class="mb-4 text-slate-500 hover:text-orange-500 transition-colors flex items-center gap-2 group text-[11px] font-bold uppercase tracking-widest">
          <v-icon small class="group-hover:-translate-x-1 transition-transform" color="inherit">mdi-arrow-left</v-icon>
          Voltar
        </button>
        <h1 class="sci-page-header-title">
          Nova Autorização de Abastecimento
        </h1>
        <p class="text-sm text-slate-500 font-medium mt-1">
          {{ $route.name }} - Selecione o fornecedor e o veículo
        </p>
      </div>

      <!-- MAIN CARD -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <!-- Divisor Escuro -->
        <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
          <v-icon color="orange" small>mdi-gas-station</v-icon>
          <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
            SELEÇÃO DE FORNECEDOR E VEÍCULO
          </h2>
        </div>

        <div class="p-6">
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="space-y-6">
              <!-- Prefecture Selection (Only for Admins or users without specific link) -->
              <div v-if="$store.getters.getUserData.group_id == 1 || $store.getters.getUserData.group_id == 5 || $store.getters.getUserData.table_key != 'prefectures'" class="bg-slate-50 p-6 rounded-xl border border-slate-200">
                <v-autocomplete
                  label="Prefeitura:"
                  :rules="fieldRules"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  v-model="data.prefecture_id"
                  @change="providers = []; vehicles = []; data.provider_id = null; getProviders(data.prefecture_id); getVehicles(data.prefecture_id)"
                  outlined
                  dense
                  class="bg-white rounded-lg"
                  hide-details
                />
              </div>

              <!-- Provider Selection -->
              <div class="bg-slate-50 p-6 rounded-xl border border-slate-200">
                <v-autocomplete
                  label="Fornecedor:"
                  :rules="fieldRules"
                  :items="providers"
                  item-value="provider_id"
                  item-text="provider_name"
                  v-model="data.provider_id"
                  outlined
                  dense
                  class="bg-white rounded-lg"
                  hide-details
                />
              </div>
              
              <!-- Vehicle Table -->
              <div class="border border-slate-200 rounded-xl overflow-hidden mt-6">
                <v-data-table
                  :headers="headers"
                  :items="vehicles"
                  :items-per-page="10"
                  :loading="loader"
                  loading-text="CARREGANDO..."
                  class="elevation-0"
                  no-data-text="Nenhum veículo encontrado"
                >
                  <template v-slot:item.model_desc="{ item }">
                    <div class="flex flex-col py-2" v-if="item.vehicle_id">
                      <span class="text-sm font-bold text-slate-800">{{ item.vehicle_board }}</span>
                      <span class="text-[10px] text-slate-500 font-medium uppercase">{{ item.brand_desc }} - {{ item.model_desc }}</span>
                    </div>
                    <span v-else class="text-slate-400 italic">Veículo não definido</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div class="flex items-center justify-end gap-2">
                      <v-btn
                        :disabled="data.provider_id === null"
                        small
                        depressed
                        color="primary"
                        :loading="loader"
                        @click="addFuelAuthorization(item)"
                        class="rounded-lg font-bold"
                      >
                        <v-icon left x-small>mdi-plus</v-icon>
                        Criar Abastecimento
                      </v-btn>
                      <v-btn
                        small
                        outlined
                        color="slate-600"
                        :loading="loader"
                        @click="loadAbastecimento(item)"
                        class="rounded-lg font-bold border-slate-300"
                      >
                        <v-icon left x-small>mdi-history</v-icon>
                        Histórico
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>

    <!-- MODAL HISTÓRICO -->
    <v-dialog v-model="showModalAbastecimento" max-width="1200px" scrollable>
      <v-card class="rounded-xl overflow-hidden">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-history</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
              {{ modalTitleAbastecimento }}
            </h2>
          </div>
          <v-btn icon dark small @click="showModalAbastecimento = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="p-0">
          <v-data-table
            :headers="headersAbastecimento"
            :items="abastecimentoData"
            :loading="loaderAbastecimento"
            loading-text="CARREGANDO..."
            class="elevation-0"
            no-data-text="Nenhuma autorização de abastecimento encontrada"
          >
            <template v-slot:item.datehour="{ item }">
              <span class="text-sm text-slate-600 font-medium">{{ convertDateTime(item.datehour) }}</span>
            </template>
            <template v-slot:item.supply_authorized_value="{ item }">
              <span class="text-sm font-bold text-slate-800">{{ realMask(Number(item.supply_authorized_value || 0).toFixed(2)) }}</span>
            </template>
            <template v-slot:item.supply_authorized_liters="{ item }">
              <span class="text-sm font-bold text-emerald-600">{{ realMaskII(Number(item.supply_authorized_liters || 0).toFixed(3)) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL NOVA AUTORIZAÇÃO -->
    <v-dialog v-model="showModal" max-width="600px" persistent>
      <v-card class="rounded-xl overflow-hidden shadow-2xl">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-plus-circle</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
              {{ modalTitle }}
            </h2>
          </div>
          <v-btn icon dark small @click="showModal = false; clearForm()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="p-6">
          <v-form ref="formMotorista" v-if="!loadingModal" v-model="validForm" lazy-validation>
            <div class="space-y-6">
              <div class="bg-indigo-50 border border-indigo-100 p-4 rounded-xl flex items-center gap-3 mb-4">
                <v-icon color="indigo">mdi-information-outline</v-icon>
                <div class="text-[11px] text-indigo-700 font-medium leading-tight">
                  Defina os detalhes da autorização extra para este veículo.
                </div>
              </div>

              <v-autocomplete
                label="Item / Combustível:"
                :rules="fieldRules"
                :items="items"
                item-value="item_id"
                :item-text="itemLabel"
                v-model="data.item_id"
                @change="onItemChange(data.item_id)"
                outlined
                dense
                class="bg-white rounded-lg"
                no-data-text="Nenhum item encontrado"
              >
                <template slot="selection" slot-scope="{ item }">
                  <span class="text-sm font-bold text-slate-700">{{ itemLabel(item) }}</span>
                  <span class="text-[10px] text-slate-500 ml-2">(R$: {{ realMask(Number(item.item_price || 0).toFixed(2)) }})</span>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <div class="flex items-center justify-between w-full">
                    <span class="text-sm font-medium">{{ itemLabel(item) }}</span>
                    <span class="text-[10px] font-bold text-emerald-600">R$: {{ realMask(Number(item.item_price || 0).toFixed(2)) }}</span>
                  </div>
                </template>
              </v-autocomplete>

              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Litros Autorizados"
                    v-model="data.supply_authorized_liters"
                    v-mask-decimal.br="3"
                    outlined
                    dense
                    class="bg-white rounded-lg"
                    :disabled="disableLitros"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Valor Autorizado (R$)"
                    v-model="data.supply_authorized_value"
                    v-mask-decimal.br="2"
                    outlined
                    dense
                    class="bg-white rounded-lg"
                    :disabled="disableValor"
                  />
                </v-col>
              </v-row>

              <div class="bg-indigo-50 border border-indigo-100 p-4 rounded-xl mt-2">
                <p class="text-[11px] text-indigo-600 font-bold uppercase tracking-wider flex items-center gap-2">
                  <v-icon color="indigo" x-small>mdi-information</v-icon>
                  Deixe os campos acima vazios ou com 0 para permitir Tanque Cheio.
                </p>
              </div>
            </div>

            <div class="flex items-center justify-end gap-4 mt-8 border-t border-slate-100 pt-6">
              <button
                type="button"
                @click="[showModal = false, clearForm()]"
                style="background: none; border: none; cursor: pointer; white-space: nowrap;"
                class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest transition-colors"
              >
                CANCELAR
              </button>
              <button
                type="button"
                @click="createSupplyAuthorization(data)"
                :disabled="loadingSubmit || !validForm"
                style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; width: auto; flex-shrink: 0;"
              >
                <v-icon v-if="loadingSubmit" small class="animate-spin" color="white">mdi-loading</v-icon>
                <v-icon v-else small color="white">mdi-check</v-icon>
                <span>CONFIRMAR AUTORIZAÇÃO</span>
              </button>
            </div>
          </v-form>
          <div v-else class="flex flex-col items-center justify-center py-12">
            <v-progress-circular
              indeterminate
              color="primary"
              size="48"
              width="4"
            ></v-progress-circular>
            <span class="mt-4 text-sm font-medium text-slate-500">Carregando detalhes...</span>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- MODAL SENHA -->
    <v-dialog v-model="showPassword" width="350" persistent>
      <v-card class="rounded-2xl overflow-hidden shadow-2xl border-2 border-indigo-100">
        <div class="bg-indigo-600 p-6 text-center">
          <v-icon color="white" large class="mb-2">mdi-lock-check</v-icon>
          <h2 class="text-white font-black text-xl tracking-tight leading-tight uppercase">
            Sua senha foi gerada!
          </h2>
        </div>
        
        <v-card-text class="p-8 text-center bg-white">
          <div class="space-y-6">
            <div class="bg-slate-50 p-6 rounded-2xl border-2 border-dashed border-slate-200">
              <input
                readonly
                class="text-4xl font-black text-indigo-700 text-center tracking-widest w-full bg-transparent border-0 outline-none"
                ref="copiar"
                :value="password"
              />
            </div>
            
            <v-btn
              :color="copiado ? 'emerald' : 'indigo'"
              depressed
              dark
              block
              large
              @click="copy"
              class="rounded-xl font-black text-sm tracking-widest h-14"
            >
              <v-icon left size="20">{{ copiado ? 'mdi-check-circle' : 'mdi-content-copy' }}</v-icon>
              {{ copiado ? "COPIADO COM SUCESSO" : "COPIAR SENHA" }}
            </v-btn>
            
            <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest">
              Apresente esta senha ao frentista no momento do abastecimento.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- NOTIFICAÇÃO -->
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{snack.message}}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["id"],
  mixins: [Helpers],
  data: () => ({
    valid: false,
    loader: false,
    showForm: false,
    showPassword: false,
    copiado: false,
    password: "",
    providers: [],
    vehicles: [],
    prefectures: [],
    items: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      supply_authorized_liters: "0",
      supply_authorized_value: "0",
      supply_status: "CONCLUIDO",
      supply_adjusted: false,
      supply_extra: true,
      supply_extra_type: 1,
      supply_liters_stocked: 0,
      supply_value: 0,
      supply_coupon: "",
      supply_km: 0,
      supply_billed: false,
      supply_bidding_price: 0,
      supply_price_day: 0,
      vehicle_id: null,
      driver_id: null,
      item_id: null,
      prefecture_id: null,
      provider_id: null,
    },
    headers: [
      { text: "Veículo", value: "model_desc" },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    headersAbastecimento: [
      { text: "Data e Hora", value: "datehour", align: "center" },
      { text: "Fornecedor", value: "provider_name" },
      { text: "Item", value: "item_description_desc" },
      { text: "Litros Autorizados", value: "supply_authorized_liters", align: "center" },
      { text: "Valor Autorizado", value: "supply_authorized_value", align: "center" },
      { text: "Status", value: "supply_status", align: "center" }
    ],
    loaderAbastecimento: false,
    abastecimentoData: [],
    showModalAbastecimento: false,
    modalTitleAbastecimento: "Abastecimentos",
    modalTitle: "Novo Abastecimento",
    showModal: false,
    loadingModal: false,
    loadingSubmit: false,
    validForm: false,
    vehicle_tank_capacity: 0
  }),
  created() {
    this.Helpers;
    const userData = this.$store.getters.getUserData;
    // Se for administrador ou não tiver vínculo específico, carregamos as prefeituras
    if (userData.group_id == 1 || userData.group_id == 5 || userData.table_key != 'prefectures') {
      this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    } 
    
    // Se tiver um vínculo específico (e não for admin, ou for um admin com ID fixado), carregamos fornecedores e veículos
    if (userData.table_key == 'prefectures' && userData.table_id) {
      this.data.prefecture_id = userData.table_id;
      this.getProviders(this.data.prefecture_id);
      this.getVehicles(this.data.prefecture_id);
    }
  },
  computed: {
    disableLitros() {
      const val = (this.data.supply_authorized_value || "0").toString().replace(',', '.');
      return parseFloat(val) > 0;
    },
    disableValor() {
      const val = (this.data.supply_authorized_liters || "0").toString().replace(',', '.');
      return parseFloat(val) > 0;
    }
  },
  methods: {
    getProviders(prefecture_id) {
      if (!prefecture_id) return;
      this.$http
        .get(`/providers/prefecture/${prefecture_id}`)
        .then((r) => (this.providers = r.data));
    },
    getVehicles(prefecture_id) {
      if (!prefecture_id) return;
      this.loader = true;
      this.$http
        .get(`/vehicles/supplies/${prefecture_id}`)
        .then((r) => {
          this.vehicles = r.data.filter(
            (v) =>
              (v.vehicle_active === 1 || v.vehicle_active === true) &&
              (v.abastecimento_extra === 1 || v.abastecimento_extra === true)
          );
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    itemLabel(item) {
      if (!item) return "";
      return item.item_description_desc || item.item_name || "";
    },
    copy() {
      var copyTextarea = this.$refs.copiar;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.copiado = true;
          setTimeout(() => {
            this.showPassword = false;
            this.copiado = false;
            this.$router.push("/supplies-manager");
          }, 1000);
        } else {
          alert("não copiado!");
        }
      } catch (err) {
        alert(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C."
        );
      }
    },
    async loadItems(provider_id, vehicle_id, prefecture_id) {
      const res = await this.$http.get(`/supplies/providers/${provider_id}/${vehicle_id}/${prefecture_id}`);
      this.items = res.data;
      this.data.item_id = null;
    },
    onItemChange(item_id) {
      const item = this.items.find((i) => i.item_id === item_id);
      if (item) {
        this.data.supply_bidding_price = item.item_price || item.item_billing_price || 0;
        this.data.supply_price_day = item.item_price || item.item_billing_price || 0;
      }
    },
    async loadAbastecimento(vehicle) {
      this.loaderAbastecimento = true;
      this.abastecimentoData = [];
      this.modalTitleAbastecimento = `Abastecimentos - Veículo: ${vehicle.vehicle_board}`;
      this.showModalAbastecimento = true;

      const filter = {
        prefecture_id: vehicle.prefecture_id,
        vehicle_id: vehicle.vehicle_id,
        all_status: true,
        supply_extra: true,
        startDate: new Date().toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
      }

      const res = await this.$http.put("/supplies/billings", filter);
      this.abastecimentoData = res.data;

      this.loaderAbastecimento = false;
    },
    clearForm() {
      const prefecture_id = this.data.prefecture_id;
      const provider_id = this.data.provider_id;
      this.data = {
        supply_authorized_liters: "0",
        supply_authorized_value: "0",
        supply_status: "CONCLUIDO",
        supply_adjusted: false,
        supply_extra: true,
        supply_extra_type: 1,
        supply_liters_stocked: 0,
        supply_value: 0,
        supply_coupon: "",
        supply_km: 0,
        supply_billed: false,
        supply_bidding_price: 0,
        supply_price_day: 0,
        vehicle_id: null,
        driver_id: null,
        item_id: null,
        prefecture_id,
        provider_id,
      };
      this.items = [];
    },
    async addFuelAuthorization(item) {
      this.clearForm();
      this.modalTitle = `Novo Abastecimento - Veículo: ${item.vehicle_board}`;
      this.showModal = true;
      this.loadingModal = true;

      this.vehicle_tank_capacity = item.vehicle_tank_capacity;

      this.data.vehicle_id = item.vehicle_id;
      await this.loadItems(this.data.provider_id, this.data.vehicle_id, this.data.prefecture_id).catch(() => {});

      this.loadingModal = false;
    },
    async createSupplyAuthorization(payload) {
      if (this.$refs.formMotorista.validate()) {
        const litersStr = (payload.supply_authorized_liters || "0").toString();
        const valueStr = (payload.supply_authorized_value || "0").toString();
        const liters = parseFloat(litersStr.replace(',', '.'));
        const value = parseFloat(valueStr.replace(',', '.'));

        try {
          this.loadingSubmit = true;
          payload.is_autorized = true;
          payload.authorizer = this.$store.getters.getUserData.user_login;
          payload.supply_status = "CONCLUIDO";
          payload.supply_extra_type = 1; // Forçado para garantir que caia no relatório de bloqueados
          
          const now = new Date();
          payload.datehour = `${String(now.getDate()).padStart(2, '0')}/${String(now.getMonth() + 1).padStart(2, '0')}/${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

          const price = parseFloat(payload.supply_price_day) || parseFloat(payload.supply_bidding_price) || 0;

          if (value === 0 && liters > 0) {
            payload.supply_value = liters * price;
            payload.supply_liters_stocked = liters;
          } else if (value > 0 && liters === 0) {
            payload.supply_value = value;
            payload.supply_liters_stocked = price > 0 ? value / price : 0;
            payload.supply_authorized_liters = payload.supply_liters_stocked.toFixed(3).replace('.', ',');
          } else {
            payload.supply_value = value;
            payload.supply_liters_stocked = liters;
          }

          payload.supply_coupon = "";
          payload.supply_km = 0;

          await this.$http.post("/supplies/single", payload);
          
          this.snack.show = true;
          this.snack.message = "Abastecimento registrado com sucesso!";
          this.snack.color = "success";
          this.loadingSubmit = false;
          this.showModal = false;
          this.clearForm();
          this.getVehicles(this.data.prefecture_id);
        } catch (error) {
          this.snack.show = true;
          this.snack.color = "error";
          this.snack.message = error.response && error.response.data 
            ? (error.response.data.error || error.response.data.message || (typeof error.response.data === 'string' ? error.response.data : error.message)) 
            : error.message;
          this.loadingSubmit = false;
        }
      }
    },
  },
};
</script>
